import type { TFunction } from "i18next";

function humanizeSlug(value: string): string {
  return value
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export function formatCertificatePricingFlow(flow: string, t: TFunction): string {
  return t(`platform.products.flows.${flow}`, {
    defaultValue: humanizeSlug(flow),
  });
}

export function formatCertificatePricingProduct(
  targetType: string,
  t: TFunction
): string {
  return t(`platform.products.typeLabels.${targetType}`, {
    defaultValue: humanizeSlug(targetType),
  });
}

/**
 * A spawned RFQ child (targetType 'custom_quote') has no title of its own —
 * combine the generic catalog label with the original RFQ's own title so
 * rows are distinguishable instead of every one reading as just "Presupuesto
 * a medida".
 */
export function formatCertificatePricingProductWithSource(
  targetType: string,
  sourceRequestTitle: string | null | undefined,
  t: TFunction
): string {
  const label = formatCertificatePricingProduct(targetType, t);
  return sourceRequestTitle ? `${label} - ${sourceRequestTitle}` : label;
}

export function formatCertificatePricingChannelBadges(
  involvesAccountant: boolean,
  involvesNotary: boolean,
  t: TFunction
): string[] {
  const badges: string[] = [];
  if (involvesNotary) badges.push(t("platform.products.flows.notary"));
  if (involvesAccountant) badges.push(t("platform.products.flows.accountant"));
  return badges;
}
